export default __webpack_public_path__ + "static/Logo-f7660f13a460079e6577ee18f8798440.png";